import { Component, OnInit } from '@angular/core';
import { User } from '../../@core/data/users'
import { UserService } from '../../@core/api/users.service'
import { AngularFireStorage } from '@angular/fire/storage';
import { NbWindowService, NbWindowState, NbWindowRef } from '@nebular/theme';
import { MessageHandlerService } from '../../services/message-handler.service'
import { LenguageService } from '../../@core/utils/lenguage.service'
@Component({
  selector: 'ngx-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.scss']
})
export class UserCreateComponent implements OnInit {

  loading: boolean = false;
  uploading: boolean = false;
  admin: boolean;
  user: User;
  id: string
  uploadProgress: any;
  constructor(private windowRef: NbWindowRef, 
    private userService: UserService, 
    private afStorage: AngularFireStorage, 
    private messageHandler: MessageHandlerService,
    public language: LenguageService) {

  }


  async ngOnInit() {
    let logged = await this.userService.getLoggedUser()
    this.admin = (logged.userType === "admin") ? true : false;
    this.user = {
      companyName: "",
      email: "",
      name: "",
      phone: "",
      userType: "",
      uid: "",
    }
  }

  async save() {

    this.loading = true;
    try {
      await this.userService.createUser(this.user)
      this.messageHandler.success();
      this.windowRef.close();
    } finally {
      this.loading = false;
    }
  }


  upload(event) {
    const randomId = Math.random().toString(36).substring(2);
    let ref = this.afStorage.ref("/profilePics/"+randomId);
    let task = ref.put(event.target.files[0]);
    this.uploading = true;
    this.uploadProgress = task.percentageChanges();
    task.then(async (a) => {
      let downloadUrl = await ref.getDownloadURL().toPromise();
      this.uploading = false;
      this.user.profilePic = downloadUrl;
    });
  }

}
